import React, { useEffect, useRef, useState } from 'react'
import styles from './ChatInput.module.scss'
import { ReactComponent as Clip } from 'components/CRM/UI/icons/clip.svg'
import CustomSelect from 'components/CRM/UI/components/CustomSelect/CustomSelect'
import asideModalStore from 'Stores/asideModalStore'
import AddFile from 'components/ContentBox/Global/GlobalModalSingle/templates/CRM/AddFile/AddFile'
import { superAxiosRequest } from 'axiosApi'
import useLocalization from 'hooks/useLocalization'

const ChatInput = ({
  inputText,
  setInputText,
  sendMessage,
  sessionId,
  addNote,
  dealData,
  setChannelId,
  channelId,
  fetchMessages,
  disabled = false,
  closeAttach = true,
  activeDealId,
}) => {
  const [channels, setChannels] = useState(null)
  const [selectedOption, setSelectedOption] = useState(null)
  const [templates, setTemplates] = useState([])

  const { translate } = useLocalization({
    section: 'crm',
    subsection: 'customer_card',
    dict: {
      note: 'Note',
      message_placeholder: 'Write your message here',
      send: 'Send',
      save: 'Save',
      add_new_file: 'Add new file',
    },
  })

  useEffect(() => {
    superAxiosRequest({
      link: `integration/channels`,
      method: 'get',
      crm: true,
    })
      .then((res) => {
        setChannels(res.data)
        setChannelId(res.data[0]?.channel_id)
        setSelectedOption(res.data[0]?.name || 'Note') // Устанавливаем первый канал как выбранный
      })
      .catch((error) => {
        console.error(error)
      })
  }, [])

  useEffect(() => {
    superAxiosRequest({
      link: `integration/templates_wazzup`,
      method: 'get',
      crm: true,
      params: {
        channel_id: channelId,
      },
    })
      .then(({ data }) => {
        const filteredTemplates = data.result.filter((el) => el.is_active)
        const updateTemplatesOptions = [
          ...(filteredTemplates || []).map((template) => ({
            name: template.title,
            text: template.text,
          })),
        ]
        setTemplates(updateTemplatesOptions)
      })
      .catch((error) => {
        console.error(error)
      })
  }, [channelId])

  const handleTemplates = (option) => {
    setInputText(option?.text)
  }

  const allOptions = [
    { name: 'Note' },
    ...(channels || []).map((channel) => ({ name: channel.name })),
  ]

  const options = sessionId
    ? dealData?.note
      ? allOptions.filter((option) => option.name !== 'Note')
      : allOptions
    : [{ name: 'Note' }]

  useEffect(() => {
    if (!sessionId) {
      setSelectedOption('Note')
    } else if (dealData?.note && selectedOption === 'Note') {
      const firstOption = options[0]
      if (firstOption?.name) {
        setSelectedOption(firstOption.name)
      }
    }
  }, [sessionId, dealData, options, selectedOption])

  const selectedChannel = channels?.find(
    (channel) => channel.name === selectedOption,
  )

  const handleSelect = (option) => {
    setSelectedOption(option.name)
    setChannelId(channels.find((el) => el.name === option.name)?.channel_id)
  }

  const handleInputChange = (e) => {
    setInputText(e.target.value)
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && inputText.trim().length) {
      if (selectedOption === 'Note') {
        addNote()
      } else {
        sendMessage(selectedChannel?.channel_id)
      }
    }
  }

  const handleButtonClick = () => {
    if (inputText.trim().length) {
      if (selectedOption === 'Note') {
        addNote()
      } else {
        sendMessage(selectedChannel?.channel_id)
      }
    }
  }

  const textareaRef = useRef(null)

  useEffect(() => {
    adjustTextareaHeight()
  }, [inputText])

  const adjustTextareaHeight = () => {
    const textarea = textareaRef.current
    textarea.style.height = '36px'
    textarea.style.height = `${textarea.scrollHeight}px`
  }

  const addFile = () => {
    const ms = {
      modalBodyComponent: () => <AddFile />,
      crm: true,
      button: translate.save,
      link: 'integration/messages',
      title: translate.add_new_file,
      onBeforeSubmit: (data) => {
        return {
          ...data,
          type_message: data?.type_message?.name || null,
        }
      },
      onSubmitSuccess: () => fetchMessages(activeDealId),
      isResponsive: true,
      valid: {
        type_message: 'required',
        file: 'required',
      },
    }
    const md = {
      session_id: sessionId,
      channel_id: selectedChannel?.channel_id,
    }
    asideModalStore.activity(ms, md)
  }

  return (
    <div className={styles.chatInputContainer}>
      {!closeAttach ? null : (
        <div className={styles.clipContainer}>
          {dealData?.session_id && (
            <Clip className={styles.clip} onClick={addFile} />
          )}
          <div className={styles.note}>
            <CustomSelect
              options={options}
              defaultOption={selectedOption}
              onSelect={handleSelect}
            />
          </div>
          {templates.length ? (
            <div className={styles.note}>
              <CustomSelect
                icon={true}
                options={templates}
                defaultOption={'Шаблоны'}
                onSelect={handleTemplates}
              />
            </div>
          ) : null}
        </div>
      )}
      <div className={styles.textFieldContainer}>
        <textarea
          ref={textareaRef}
          placeholder={`${translate.message_placeholder}...`}
          value={inputText}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
          className={styles.inputTextarea}
        />
        <button
          className={styles.button}
          onClick={handleButtonClick}
          disabled={disabled}
        >
          {translate.send}
        </button>
      </div>
    </div>
  )
}

export default ChatInput
